import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Alert, Modal } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'

export const RemoveConfirmModal = ({
  modalTitle,
  message,
  endpoint,
  show,
  toggle,
  currentState,
  dispatch,
}) => {
  const [errorText, updateErrorText] = useState(null)

  const removeHandler = async () => {
    try {
      await client.delete(endpoint)
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully removed."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toggle(!show)
      updateErrorText(null)
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          ButterToast.raise({
            content: (
              <Cinnamon.Crisp
                title={err.response.statusText}
                content={err.response.data.error}
                scheme={Cinnamon.Crisp.SCHEME_RED}
                icon={<i className="far fa-thumbs-down fa-3x" />}
              />
            ),
          })
        } else {
          updateErrorText(err.response.data.error)
        }
      } else {
        updateErrorText(err)
      }
    }
  }

  const closeModalHandler = () => {
    toggle(!show)
    updateErrorText(null)
  }

  let errorAlert = errorText ? (
    <Alert className="alert-danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={closeModalHandler}>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <p>{message}</p>
        <div
          className="btn btn-danger btn-myed btn-danger-myed"
          onClick={removeHandler}
        >
          <div className="far fa-window-close fa-fw mr-2" /> Remove
        </div>
      </Modal.Body>
    </Modal>
  )
}

RemoveConfirmModal.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  currentState: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}
